import type { GamePhase } from "@fate-kingdom/engine";
import { useState } from "react";

import { AlphaGameIcon } from "../icons/AlphaGameIcon";
import { ALPHA_PHASE_COPY } from "./alpha-tutorial-guide";

const PHASES: readonly GamePhase[] = ["ready", "supply", "action-window", "cleanup"];

export function AlphaPhaseRail({ phase }: { readonly phase: GamePhase }) {
  const [explanationOpen, setExplanationOpen] = useState(false);
  const currentIndex = PHASES.indexOf(phase);
  const current = ALPHA_PHASE_COPY[phase];
  return (
    <section className="alpha-phase-rail" aria-label="Turn flow">
      <div className="alpha-phase-rail__steps">
        {PHASES.map((entry, index) => {
          const active = entry === phase;
          const complete = currentIndex > index;
          const className = `alpha-phase-rail__step ${active ? "is-current" : ""} ${complete ? "is-complete" : ""}`;
          return active ? (
            <button
              className={className}
              type="button"
              key={entry}
              aria-expanded={explanationOpen}
              onClick={() => setExplanationOpen((open) => !open)}
            >
              <AlphaGameIcon name="phase" aria-hidden="true" />
              <span>{ALPHA_PHASE_COPY[entry].title}</span>
            </button>
          ) : (
            <span
              className={className}
              key={entry}
              aria-label={`${ALPHA_PHASE_COPY[entry].title}${complete ? ", complete" : ", upcoming"}`}
            >
              <AlphaGameIcon name="phase" aria-hidden="true" />
              <span>{ALPHA_PHASE_COPY[entry].title}</span>
            </span>
          );
        })}
      </div>
      {explanationOpen ? (
        <p className="alpha-phase-rail__explanation">
          <strong>{current.title}:</strong> {current.description}
        </p>
      ) : null}
    </section>
  );
}
